import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { XCircle } from 'react-feather';

import * as COMPANIES_SELECTORS from '../../../store/selectors/companies';

import { LOCALE_NAMESPACE } from '../../../const/translations/LOCALE_NAMESPACE';

import { emptyFunc } from '../../../helpers/function/emptyFunc';

import styles from './BuySubscriptionErrorDialog.module.scss';

const T_PREFIX = 'subscriptionsScreen.dialogs.buyError';

const BuySubscriptionErrorDialog = (props) => {
    const {
        isVisible,
        onClose,
    } = props;

    const { t } = useTranslation(LOCALE_NAMESPACE.COMMON);

    const { tintColor } = useSelector(COMPANIES_SELECTORS.companiesSelector);

    const closeButtonStyle = useMemo(() => ({
        background: tintColor,
    }), [tintColor]);

    return (
        <Modal
            show={isVisible}
            container={document.getElementById('root_appybee_widget')}
            onHide={onClose}
        >
            <Modal.Body>
                <div className={styles.contentContainer}>
                    <XCircle
                        size={67}
                        color={'red'}
                    />

                    <span className={styles.contentTitle}>
                        {t(`${T_PREFIX}.body.title`)}
                    </span>
                </div>
            </Modal.Body>
            <Modal.Footer className={styles.dialogFooter}>
                <Button
                    style={closeButtonStyle}
                    className={styles.closeButton}
                    onClick={onClose}
                >
                    {t(`${T_PREFIX}.body.actions.close`)}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

BuySubscriptionErrorDialog.propTypes = {
    isVisible: PropTypes.bool,
    onClose: PropTypes.func,
};

BuySubscriptionErrorDialog.defaultProps = {
    visible: false,
    onClose: emptyFunc,
};

export default BuySubscriptionErrorDialog;
